export const BASE_URL = "https://api.ushell.ru"
